/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-touch-1': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M12.5 5h-1.25A3.125 3.125 0 005 5H3.75a4.375 4.375 0 018.75 0zm3.125 4.375c-.323.001-.64.087-.919.25a1.875 1.875 0 00-1.581-.875c-.323.001-.64.087-.919.25A1.875 1.875 0 0010 8.238V5a1.875 1.875 0 10-3.75 0v6.938l-1.394-.95a1.831 1.831 0 00-1.106-.363 1.875 1.875 0 00-1.325 3.206l5 4.563a3.85 3.85 0 002.575.981h3.125A4.375 4.375 0 0017.5 15v-3.75c0-1.036-.84-1.875-1.875-1.875zM16.25 15c0 1.726-1.4 3.125-3.125 3.125H10a2.606 2.606 0 01-1.725-.625l-4.969-4.563a.625.625 0 01.164-.996.625.625 0 01.655.059L7.5 14.313V5a.625.625 0 111.25 0v6.875H10V10a.625.625 0 111.25 0v1.875h1.25v-1.25a.625.625 0 111.25 0v1.25H15v-.625a.625.625 0 111.25 0V15z"/>'
  }
})
